
import request from '@/service/request'

export const getProductPage = (params: COMMON.API.QueryParams) => {
  return request<SERVICE.ResponsePage<PRODUCT.Detail[]>>({
    url: '/admin/product/page',
    method: 'GET',
    params
  })
}

export const addProduct = (data: PRODUCT.Detail) => {
  return request<SERVICE.Response<string>>({
    url: '/admin/product',
    method: 'POST',
    data
  })
}

export const getProductById = (id: string) => {
  return request<SERVICE.Response<string>>({
    url: '/admin/product/' + id,
    method: 'GET'
  })
}

export const updateProduct = (data: PRODUCT.Detail) => {
  return request<SERVICE.Response<string>>({
    url: '/admin/product',
    method: 'PUT',
    data
  })
}

export const delProduct = (id: string) => {
  return request<SERVICE.Response<string>>({
    url: '/admin/product/' + id,
    method: 'DELETE'
  })
}

export const getProductCategory = () => {
  return request<SERVICE.Response<string>>({
    url: '/admin/product-category',
    method: 'GET'
  })
}

export const updateProductCategoryById = (data) => {
  return request<SERVICE.Response<string>>({
    url: '/admin/product-category',
    method: 'PUT',
    data
  })
}

export const addProductCategory = (data) => {
  return request<SERVICE.Response<string>>({
    url: '/admin/product-category',
    method: 'POST',
    data
  })
}

export const delProductCategoryById = (id) => {
  return request<SERVICE.Response<string>>({
    url: '/admin/product-category/' + id,
    method: 'DELETE'
  })
}
